import React from "react";
import NityasevaTableRow from "./NityasevaTableRow";

const NityasevaTable = ({ 
  title, 
  totalnityaPages, 
  nityapage, 
  setNityapage, 
  paginationDisable, 
  donor, 
  nityasevas,
  onStatusUpdate 
}) => {
  
  const handlePageChange = (newPage) => {
    if (!paginationDisable && newPage >= 1 && newPage <= totalnityaPages) {
      setNityapage(newPage);
    }
  };

  const renderPaginationButton = (page, label, disabled = false) => (
    <li className={`page-item ${disabled ? "disabled" : ""}`} key={page}>
      <button
        type="button"
        className="page-link"
        onClick={() => handlePageChange(page)}
        disabled={disabled}
      >
        {label}
      </button>
    </li>
  );

  const renderArrowButton = (direction, disabled = false) => {
    const isNext = direction === 'next';
    const targetPage = isNext ? nityapage + 1 : nityapage - 1;
    
    return (
      <li className={`page-item ${disabled ? "disabled" : ""}`}>
        <button
          type="button"
          className="page-link arrow"
          onClick={() => handlePageChange(targetPage)}
          disabled={disabled}
        >
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 256 512"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d={isNext 
              ? "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
              : "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
            }></path>
          </svg>
        </button>
      </li>
    );
  };

  return (
    <div className="donation-table">
      <h5 className="table-title mt-lg-5 mt-3 mb-lg-3 mb-0">{title}</h5>

      {/* Table Header - Desktop */}
      <div className="table-heading py-4 d-none d-lg-block">
        <div className="row">
          <div className="col-lg-2">
            <h5>Date</h5>
          </div>
          <div className="col-lg-2">
            <h5>Purpose</h5>
          </div>
          <div className="col-lg-2">
            <h5>Status</h5>
          </div>
          <div className="col-lg-2">
            <h5>Name</h5>
          </div>
          <div className="col-lg-2">
            <h5>Amount</h5>
          </div>
          <div className="col-lg-2">
            <h5>Action</h5>
          </div>
        </div>
      </div>

      {/* Table Content */}
      <div className="table-content pt-2 pt-lg-0">
        <div className="row">
          <div className="col-12">
            <div className="table-row">
              {nityasevas && nityasevas.length > 0 ? (
                nityasevas.map((nityaseva, i) => (
                  <NityasevaTableRow 
                    key={`${nityaseva.id}-${i}`} 
                    nityaseva={nityaseva} 
                    onStatusUpdate={onStatusUpdate}
                  />
                ))
              ) : (
                <div className="text-center py-5">
                  {!donor ? (
                    <h5 className="text-muted">Unable to show details</h5>
                  ) : (
                    <h5 className="text-muted">No Nitya Seva records found</h5>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Pagination */}
      {nityasevas && nityasevas.length > 0 && totalnityaPages > 1 && (
        <nav aria-label="Nitya seva pagination">
          <ul className="pagination justify-content-center mt-4">
            {/* Previous Arrow */}
            {renderArrowButton('prev', nityapage === 1 || paginationDisable)}
            
            {/* Previous Page Number */}
            {nityapage > 1 && 
              renderPaginationButton(nityapage - 1, nityapage - 1, paginationDisable)
            }
            
            {/* Current Page */}
            <li className="page-item active">
              <span className="page-link">{nityapage}</span>
            </li>
            
            {/* Next Page Number */}
            {nityapage < totalnityaPages && 
              renderPaginationButton(nityapage + 1, nityapage + 1, paginationDisable)
            }
            
            {/* Next Arrow */}
            {renderArrowButton('next', nityapage === totalnityaPages || paginationDisable)}
          </ul>
          
          {/* Pagination Info */}
          <div className="text-center mt-2">
            <small className="text-muted">
              Page {nityapage} of {totalnityaPages}
            </small>
          </div>
        </nav>
      )}
    </div>
  );
};

export default NityasevaTable;